// @workflow assistant.voice
/**
 * Read aloud wired to the browser and the API: one player for the page. MediaSource is used when
 * it plays audio/mpeg (Chrome, Edge); otherwise the reply is downloaded first and played as a blob.
 */
import { API_AUTH } from '@Assistant/services/apiAuth';
import { createReadAloudClient } from '@Assistant/services/readAloudClient';
import { createReadAloudPlayer } from '@Assistant/services/readAloudPlayer';

export const readAloudPlayer = createReadAloudPlayer({
  client: createReadAloudClient(API_AUTH),
  createAudio: () => new Audio(),
  MediaSourceImpl: window.MediaSource || null,
  urls: window.URL,
});
